import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 保存確認ダイアログ
 * WebCADを未保存で終了しようとした際に表示
 */
class ConfirmSavePlan extends Dialog {
    targetModule: number;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'confirmSavePlanDialog';
      const title = '';
      let contents = '';
      let footer = '';
      // 物件情報の有無によって、ダイアログの中身を変更する
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.bukenId === 0) {
        contents = '<div class="confirmChangeModuleDialog notationMessage" >\n';
        contents += '<span>図面を登録しますか？</span>';
        contents += '</div>\n';

        footer = '<button value="1"><span>登録する</span></button>';
        footer += '<button value="2"><span>破棄する</span></button>';
        footer += '<button value="0"><span>編集に戻る</span></button>';
      } else {
        contents = '<div class="confirmChangeModuleDialog notationMessage" >\n';
        contents += '<span>変更内容を保存しますか？</span>';
        contents += '</div>\n';

        footer = '<button value="1"><span>保存する</span></button>';
        footer += '<button value="2"><span>保存しない</span></button>';
        footer += '<button value="0"><span>編集に戻る</span></button>';
      }

      this.createDialog(id, title, contents, footer);

      this.viewObj.querySelectorAll('button').forEach((element) => {
        element.addEventListener('click', this.btnEventHandler);
      });
    }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      e.preventDefault();

      console.log((e.currentTarget).value);
      switch (Number((e.currentTarget).value)) {
        case 0: // キャンセル
          this.close();
          break;
        case 1: // はい
          this.close();

          // 保存後閉じるフラグを立てる
          marietta.webcad.WebCADGlobal.webcad2Dmanager.closeWebcadAfterEvent = true;

          document.getElementById('btnSave2').click();
          break;
        case 2: // いいえ
          // ページ更新確認ダイアログを一時的に解除
          window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
          // 図面が登録されていなかった場合
          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.bukenId === 0) {
            // パラメータを破棄状態にする
            marietta.webcad.WebCADGlobal.webcad2Dmanager.hasBeenSaved = false;
          }
          // eslint-disable-next-line no-restricted-globals
          this.close();
          // marietta.webcad.WebCADGlobal.showAlert('ブラウザを閉じてください。');
          // 終了時に連携しているパラメータをもとに画面遷移
          marietta.webcad.WebCADGlobal.backLiDARPage();
          // location.href = marietta.webcad.WebCADGlobal.webcad2Dmanager.return_url;
          break;
        default: break;
      }
    }
}
export default ConfirmSavePlan;
